module.exports = __webpack_public_path__ + "img/language-icon.aedfee9c.svg";